import { createSearchParams } from "react-router-dom";

import { FiltersType } from "@hooks/useFiltersQuery/utils";

import { TGradient } from "@store/actions/quickFilters";

import { sortValues } from "@utils/constants";

enum EFiltersForm {
  Bpm = "bpm",
  Length = "length",
}

export const getDirtyAmount = (values: Record<string, string[]>) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    if (
      !value ||
      key === FiltersType.IS_FILTERS_OPEN ||
      key === FiltersType.IS_ALBUMS_TAB ||
      key === FiltersType.PAGE_NUMBER ||
      key === FiltersType.SORT
    ) {
      return acc;
    }
    if (key === EFiltersForm.Length || key === EFiltersForm.Bpm) {
      const length = Math.round(value.filter(Boolean).length / 2);
      return acc + length;
    }
    return acc + value.length;
  }, 0);
};

export const toRgba = (color: string, alpha: number) => {
  if (color.startsWith("rgba") || color.startsWith("rgb")) {
    return color;
  }

  let r = 0,
    g = 0,
    b = 0;
  if (color.length === 4) {
    r = parseInt(color[1] + color[1], 16);
    g = parseInt(color[2] + color[2], 16);
    b = parseInt(color[3] + color[3], 16);
  } else if (color.length === 7) {
    r = parseInt(color[1] + color[2], 16);
    g = parseInt(color[3] + color[4], 16);
    b = parseInt(color[5] + color[6], 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getGradient = (gradientProps: TGradient) => {
  if (!gradientProps) {
    return "";
  }
  const { direction, colors, shape, type } = gradientProps;
  const c1 = toRgba(colors[0].hex, colors[0].opacity);
  const c2 = toRgba(colors[1].hex, colors[1].opacity);

  return type === "linear-gradient" ? `${type}(${direction}, ${c1}, ${c2})` : `${type}(${shape}, ${c1}, ${c2})`;
};

export const getSort = (key: string) => {
  return sortValues((i) => i).find((item) => item.value === key);
};

export const buildUrl = (fields: { key: string; value: string }[], additionalValues?: Record<string, any>) => {
  const params = new URLSearchParams(location.search);
  fields.forEach(({ key, value }) => {
    params.set(key, value);
  });

  return createSearchParams({ ...Object.fromEntries(params), ...additionalValues });
};
